import React, { useRef } from 'react';

import { Button } from 'antd';

import NewForm from '../../components/Integration/NewForm';
import Table from '../../components/Integration/Table';
import Page from '../../layout/Page';
import { ButtonContainer } from './styles';

function Integration() {
  const newRef = useRef();

  return (
    <Page title="Gerenciador de integração das aplicações" selectedKey="4">
      <ButtonContainer>
        <Button type="primary" onClick={() => newRef.current.open()}>
          Cadastrar
        </Button>
      </ButtonContainer>
      <NewForm ref={newRef} />
      <Table />
    </Page>
  );
}

export default Integration;
